<template>
  <div class="progress-review">
    <h3 class="progress-review__title">You're almost done!</h3>
    <p class="progress-review__message">
      Before finishing this course, would you tell us what you think about the
      content and the instructor?
    </p>
    <div class="progress-review__actions">
      <a class="progress-review__link" href="#" @click="noThanks">
        No, thank you
      </a>
      <Action
        @click="handleClick"
        ofType="large"
        :content="`Review now`"
        :customClass="'progress-review__review-btn'"
      />
    </div>
  </div>
</template>
<script>
import Action from '@/components/shared/Action.vue'

export default {
  name: 'ProgressReviewModal',
  props: {
    progress: {
      type: Number,
      required: true,
    },
  },
  components: {
    Action,
  },
  methods: {
    noThanks(e) {
      let payload = null
      e.preventDefault()
      if (parseInt(this.progress) >= 50 && parseInt(this.progress) < 90) {
        payload = {
          prompt_review_50_perc_completion: true,
        }
      } else if (parseInt(this.progress) >= 90) {
        payload = {
          prompt_review_90_perc_completion: true,
        }
      }
      this.$store.dispatch('courses/toggleUserStatusInfo', payload)
      this.$store.dispatch('courses/sendCourseUserPreferences', payload)
    },
    handleClick() {
      this.$store.dispatch('courses/toggleRatingModal', true)
    },
  },
}
</script>
<style lang="scss" scoped>
.progress-review {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background: var(--white) 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 99px #000000ba;
  border-radius: 24px;
  max-width: 400px;
  padding: 0 20px 20px 20px;
  z-index: 2;
  transition-delay: 2s;
  &__title {
    font-size: rem(20px);
    font-family: var(--font-bold);
    margin-bottom: 0;
  }
  &__actions {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
  }
  &__link {
    color: var(--black);
    font-weight: bold;
    font-family: var(--font-bold);
  }
  &__review-btn {
    border-color: var(--orange) !important;
    color: var(--black);
  }
}
</style>
